module.exports = {
  "country": "DK",
  "artist": "Emmelie de Forest",
  "song": "Only Teardrops",
  "year": "2013",
  "place": "1",
  "spotify": "3yRwgprKX3If2zcuGfKFBu"
};